import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import PanelMaterial from '../../MACRA_1/components/PanelMaterial/PanelMaterial';
import Layout from '../../components/Layout/Layout';
import isAdminUser from '../../hoc/isAdminUser';
import './Backoffice.scss';
import { IBackofficeProps } from './IBackoffice';
import PanelTemplateMacra2 from '../../MACRA_2/components/PanelTemplate/PanelTemplateMacra2';
import PanelTemplateMarca1 from '../../MACRA_1/components/PanelTemplate/PanelTemplateMarca1';
import PanelDocument from '../../components/panelDocument/PanelDocument';

const Backoffice = (props: IBackofficeProps) => {
    const { t } = useTranslation();

    return (
        <Layout>
            <div className='backoffice'>
                <Tabs>
                    <TabList>
                        <Tab>{t('backoffice_templates_channel_and_bank_protection')}</Tab>
                        <Tab>{t('backoffice_templates_grade_control_structure')}</Tab>
                        <Tab>{t('backoffice_materials')}</Tab>
                        <Tab>{t('header_help_button')}</Tab>
                    </TabList>
                    <TabPanel>
                        <PanelTemplateMarca1 />
                    </TabPanel>
                    <TabPanel>
                        <PanelTemplateMacra2 />
                    </TabPanel>
                    <TabPanel>
                        <PanelMaterial />
                    </TabPanel>
                    <TabPanel>
                        <PanelDocument />
                    </TabPanel>
                </Tabs>
            </div>
        </Layout>
    );
};
export default isAdminUser(Backoffice);
